module.exports = __webpack_public_path__ + "teqbahn-assets/media/1.3bb567ce.pdf";